export default "__VITE_ASSET__Dq8L7x49__"